import React from 'react';
import '../styles/AvisoLegal.css';

const AvisoLegal = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="aviso-hero-section">
        <div className="aviso-hero-container">
          <div className="aviso-hero-card">
            <h1 className="aviso-hero-title">
              Aviso <span className="aviso-hero-title-gradient">Legal</span>
            </h1>
            <p className="aviso-hero-description">
              Términos y condiciones de uso del sitio web de la Red Sísmica del Noroeste de México
            </p>
          </div>
        </div>
      </header>

      {/* Contenido Principal */}
      <section className="aviso-content-section">
        <div className="aviso-content-container">
          {/* Introducción */}
          <div className="aviso-section">
            <div className="aviso-intro">
              <p>
                La página web de la RESNOM tiene el propósito de informar sobre la actividad sísmica de la zona noroeste de
                México y proporcionar a los usuarios que así lo soliciten datos de los sismos registrados. Todos los
                servicios ofrecidos por la RESNOM en su sitio web son de carácter gratuito.
              </p>
              <p>
                A través de este Aviso Legal se pretende regular el acceso y uso, y en general, la relación entre el
                sitio web (en adelante "Sitio") accesible en la dirección de Internet https://resnom.cicese.mx, y los
                usuarios del Sitio (en adelante "usuarios").
              </p>
            </div>
          </div>

          {/* Copyright */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-copyright"></i> Aviso de Copyright
            </h2>
            <div className="aviso-section-content">
              <p>
                © {currentYear} RESNOM - Red Sísmica del Noroeste de México, Departamento de Sismología CICESE,
                todos los derechos reservados. Esta página y su contenido pueden ser reproducidos con fines no lucrativos,
                siempre y cuando no se mutile, se cite la fuente completa y su dirección electrónica. De otra forma,
                requiere autorización previa por escrito de la institución.
              </p>
              <p>
                DOI: <a href="https://doi.org/10.7914/SN/BC" target="_blank" rel="noopener noreferrer">
                  https://doi.org/10.7914/SN/BC
                </a>
              </p>
            </div>
          </div>

          {/* Exención de Responsabilidad */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-exclamation-triangle"></i> Exención de Responsabilidad
            </h2>

            <h3 className="aviso-subsection-title">Uso de los datos por terceros</h3>
            <div className="aviso-section-content">
              <p>
                La utilización de los datos se realizará por parte de los usuarios bajo su propia responsabilidad,
                cuenta y riesgo, correspondiéndoles a ellos en exclusiva responder frente a terceros por daños y
                omisiones que pudieran derivarse de ella.
              </p>
              <p>
                La RESNOM no se hace responsable del uso que de su información hagan los usuarios, ni tampoco de los
                daños sufridos o pérdidas económicas que, de forma directa o indirecta, produzcan o puedan producir
                perjuicios económicos, materiales o sobre datos, provocados por el uso de la información.
              </p>
            </div>

            <h3 className="aviso-subsection-title">Precisión y veracidad de los datos proporcionados</h3>
            <div className="aviso-section-content">
              <p>
                En este sitio se presenta la información con la mayor calidad posible. No obstante lo anterior,
                la RESNOM no asume responsabilidad legal alguna o de cualquier otra índole por la precisión,
                oportunidad, contenido o uso de la misma.
              </p>
            </div>

            <h3 className="aviso-subsection-title">Disponibilidad del servicio</h3>
            <div className="aviso-section-content">
              <p>
                La RESNOM presenta su contenido de forma continua, empleando todos los medios técnicos a su alcance
                para realizar dicha prestación de forma satisfactoria. Sin embargo, la RESNOM no se hace responsable
                por los daños y perjuicios de toda naturaleza que pudieran derivarse de la disponibilidad y
                continuidad técnica del funcionamiento del sitio.
              </p>
            </div>

            <h3 className="aviso-subsection-title">Enlaces externos</h3>
            <div className="aviso-section-content">
              <p>
                La RESNOM puede facilitar el acceso a otras páginas web que considere pueden ser de interés en el
                tema de la sismología. El objetivo de proporcionar dichos enlaces es únicamente para facilitar
                la búsqueda de información que sea de interés a través de Internet.
              </p>
              <p>
                No obstante, dichas páginas no le pertenecen, ni hace una revisión de sus contenidos y, por ello,
                no se hace responsable de los contenidos, del funcionamiento de la página enlazada o de los posibles
                daños que puedan derivarse del acceso o uso de la misma.
              </p>
            </div>
          </div>

          {/* Condiciones de Acceso y Uso */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-file-contract"></i> Condiciones de Acceso y Uso
            </h2>
            <div className="aviso-section-content">
              <p>
                Al hacer uso del sitio web de la RESNOM, el usuario acepta los siguientes términos y condiciones:
              </p>

              <h3 className="aviso-subsection-title">El Usuario:</h3>
              <ul className="aviso-list">
                <li>
                  Se compromete a utilizar este sitio y sus contenidos de conformidad con la ley, la moral y
                  las buenas costumbres generalmente aceptadas por la sociedad y el orden público.
                </li>
                <li>
                  Se prohíbe la subcontratación o subarrendamiento a terceros de los servicios y/o contenidos del sitio.
                </li>
                <li>
                  Acepta y se compromete a utilizar la información con fines lícitos y sin fines de lucro.
                </li>
                <li>
                  Reconoce que el acceso y uso del sitio es bajo su propia responsabilidad.
                </li>
              </ul>

              <h3 className="aviso-subsection-title">RESNOM:</h3>
              <ul className="aviso-list">
                <li>
                  Presta sus contenidos de forma continua, empleando todos los medios técnicos a su alcance para
                  realizar dicha prestación de forma satisfactoria.
                </li>
                <li>
                  Podrá, cuando lo considere necesario, realizar correcciones, mejoras o modificaciones a la
                  información contenida en el sitio o en los contenidos de la misma, sin que ello dé lugar, ni
                  derecho a ninguna reclamación o indemnización, ni implique reconocimiento de responsabilidad alguna.
                </li>
                <li>
                  No se hace responsable del funcionamiento de la red de comunicaciones, por lo que no se
                  responsabiliza de la disponibilidad continua del sitio.
                </li>
              </ul>
            </div>
          </div>

          {/* Protección de Datos Personales */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-shield-alt"></i> Protección de Datos Personales y Privacidad
            </h2>
            <div className="aviso-section-content">
              <p>
                El acceso a los servicios suministrados a través del sitio, en algunos casos, no requiere la previa
                suscripción o registro de los usuarios. Sin embargo, para acceder a determinados servicios o
                información se requerirá el correspondiente registro de usuario.
              </p>
              <p>
                La RESNOM está comprometido con la protección de los datos personales de conformidad con la Ley Federal
                de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y su reglamento.
              </p>

              <h3 className="aviso-subsection-title">Compromisos del Usuario:</h3>
              <ul className="aviso-list">
                <li>
                  Garantizar la veracidad y autenticidad de la información proporcionada al momento de su registro.
                </li>
                <li>
                  Aceptar la presente política de privacidad.
                </li>
                <li>
                  Mantener la confidencialidad de sus credenciales de acceso, si aplica.
                </li>
              </ul>

              <h3 className="aviso-subsection-title">Compromisos de la RESNOM:</h3>
              <ul className="aviso-list">
                <li>
                  Proteger la información personal proporcionada por los usuarios a través del sitio web.
                </li>
                <li>
                  Los datos personales ingresados al llenar cualquier formulario dentro del sitio web no serán
                  difundidos, distribuidos o comercializados con terceros.
                </li>
                <li>
                  Garantizar la privacidad y el derecho a la autodeterminación informativa de las personas.
                </li>
                <li>
                  Respetar y salvaguardar los principios de licitud, consentimiento, información, calidad, finalidad,
                  lealtad, proporcionalidad y responsabilidad respecto de los datos personales.
                </li>
                <li>
                  Tratar los datos personales de acuerdo con las disposiciones de la LFPDPPP.
                </li>
                <li>
                  Mantener la confidencialidad de los datos personales y tratarlos exclusivamente para las finalidades
                  para las que fueron solicitados u obtenidos.
                </li>
                <li>
                  Abstenerse de recabar cualquier dato personal que no sea necesario para los fines de las actividades
                  que desarrolla.
                </li>
                <li>
                  Atender los procedimientos relacionados con el ejercicio de los derechos ARCO (Acceso, Rectificación,
                  Cancelación y Oposición) de los titulares de datos personales.
                </li>
                <li>
                  Establecer y mantener medidas de seguridad para proteger los datos personales.
                </li>
                <li>
                  Notificar a los titulares de los datos personales de cualquier vulneración a la seguridad de sus
                  datos que pueda afectar sus derechos patrimoniales y morales.
                </li>
              </ul>
            </div>
          </div>

          {/* Derechos ARCO */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-user-shield"></i> Derechos ARCO
            </h2>
            <div className="aviso-section-content">
              <p>
                Los usuarios tienen derecho a ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición
                (derechos ARCO) respecto de sus datos personales, de conformidad con lo establecido en la LFPDPPP.
              </p>
              <p>
                Para ejercer estos derechos, los usuarios pueden contactar a la RESNOM a través de los medios de
                contacto proporcionados en este sitio web.
              </p>
            </div>
          </div>

          {/* Cookies y Tecnologías de Seguimiento */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-cookie-bite"></i> Cookies y Tecnologías de Seguimiento
            </h2>
            <div className="aviso-section-content">
              <p>
                Este sitio web puede utilizar cookies y otras tecnologías de seguimiento con el fin de mejorar la
                experiencia del usuario, analizar el uso del sitio y proporcionar contenido personalizado.
              </p>
              <p>
                Las cookies son pequeños archivos de texto que se almacenan en el dispositivo del usuario y permiten
                al sitio recordar información sobre su visita. Los usuarios pueden configurar su navegador para
                rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.
              </p>
            </div>
          </div>

          {/* Modificaciones */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-edit"></i> Modificaciones al Aviso Legal
            </h2>
            <div className="aviso-section-content">
              <p>
                La RESNOM se reserva el derecho de modificar el presente Aviso Legal en cualquier momento. Cualquier
                cambio será publicado en esta página y entrará en vigor inmediatamente después de su publicación.
              </p>
              <p>
                Se recomienda a los usuarios revisar periódicamente este Aviso Legal para estar informados de
                cualquier actualización.
              </p>
            </div>
          </div>

          {/* Legislación Aplicable */}
          <div className="aviso-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-gavel"></i> Legislación Aplicable y Jurisdicción
            </h2>
            <div className="aviso-section-content">
              <p>
                El presente Aviso Legal se rige por las leyes de los Estados Unidos Mexicanos. Para cualquier
                controversia que pudiera derivarse del acceso o uso de este sitio web, las partes se someten
                expresamente a la jurisdicción de los tribunales competentes en Ensenada, Baja California, México.
              </p>
            </div>
          </div>

          {/* Contacto */}
          <div className="aviso-section aviso-contact-section">
            <h2 className="aviso-section-title">
              <i className="fas fa-envelope"></i> Contacto
            </h2>
            <div className="aviso-section-content">
              <p>
                Para cualquier consulta, aclaración o ejercicio de derechos relacionados con este Aviso Legal o
                la protección de datos personales, los usuarios pueden contactar a:
              </p>
              <div className="aviso-contact-info">
                <p><strong>Red Sísmica del Noroeste de México (RESNOM)</strong></p>
                <p>Departamento de Sismología CICESE</p>
                <p>Carretera Ensenada-Tijuana No. 3918</p>
                <p>Zona Playitas, C.P. 22860</p>
                <p>Ensenada, Baja California, México</p>
                <p>Email: <a href="mailto:anunez@cicese.mx">anunez@cicese.mx</a></p>
                <p>Teléfono: +52 (646) 175-0500</p>
              </div>
              <p className="aviso-update-date">
                <em>Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AvisoLegal;
